import React from 'react'
import './stepper.scss'

interface StepperProps {
	steps: Array<{ title: string, value: number, icon?: any }>;
	currentStep: number;
}

const Stepper = React.forwardRef(({ steps, currentStep }: StepperProps, ref) => {
	let currentStepIdx = steps.findIndex(item => item.value == currentStep)
	return (
		<div className="a-stepper-container" ref={ref as any}>
			<div className="a-stepper-container__box">
				{
					steps.map((step, idx) => (
						<React.Fragment key={`${step.title}-${idx}`}>
							<div className={`a-stepper-container__box__step ${currentStepIdx === idx ? 'a-stepper-container__box__step--active' : ''} 
                            ${idx < currentStepIdx ? 'a-stepper-container__box__step--checked' : ''}`}>
								{<p>&#10003;<span className='a-stepper-container__box__step__separador'></span>{step.title}</p> }
							</div>
						</React.Fragment>
					))
				}
			</div>
		</div>
	);
}
);

export default Stepper